import config from '../../content/places/arenal/geo/config.json'

export const METERS_PER_UNIT = config.metersPerUnit
export const GEO_ORIGIN = config.origin
export const GEO_BOUNDS = config.bounds

const M_PER_DEG_LAT = 111_320

function mPerDegLon(lat: number): number {
  return M_PER_DEG_LAT * Math.cos((lat * Math.PI) / 180)
}

/** WGS84 → local equirectangular XZ. +X east, +Z south. */
export function latLonToWorld(lat: number, lon: number): { x: number; z: number } {
  const east = (lon - GEO_ORIGIN.lon) * mPerDegLon(GEO_ORIGIN.lat)
  const north = (lat - GEO_ORIGIN.lat) * M_PER_DEG_LAT
  return {
    x: east / METERS_PER_UNIT,
    z: -north / METERS_PER_UNIT,
  }
}

export function worldToLatLon(x: number, z: number): { lat: number; lon: number } {
  const east = x * METERS_PER_UNIT
  const north = -z * METERS_PER_UNIT
  return {
    lat: GEO_ORIGIN.lat + north / M_PER_DEG_LAT,
    lon: GEO_ORIGIN.lon + east / mPerDegLon(GEO_ORIGIN.lat),
  }
}

const northWest = latLonToWorld(GEO_BOUNDS.north, GEO_BOUNDS.west)
const southEast = latLonToWorld(GEO_BOUNDS.south, GEO_BOUNDS.east)

export const WORLD_BOUNDS = {
  minX: northWest.x,
  maxX: southEast.x,
  minZ: northWest.z,
  maxZ: southEast.z,
  width: southEast.x - northWest.x,
  depth: southEast.z - northWest.z,
}

export const ANCHORS = {
  peak: latLonToWorld(10.4620845, -84.7034096),
  laFortuna: latLonToWorld(10.4709, -84.6453),
  lakeCenter: latLonToWorld(10.505167, -84.872168),
  dam: latLonToWorld(10.4752016, -84.7607867),
  chato: latLonToWorld(10.4429152, -84.6882932),
}

export function containsWorld(x: number, z: number): boolean {
  return (
    x >= WORLD_BOUNDS.minX &&
    x <= WORLD_BOUNDS.maxX &&
    z >= WORLD_BOUNDS.minZ &&
    z <= WORLD_BOUNDS.maxZ
  )
}
